module.exports = __webpack_public_path__ + "img/code.21a8c1ce.svg";